<template>
	<div class="white" style="color: black">
		<v-container fluid style="max-width: 1200px">
			<div class="d-md-flex ba block w-100 mb-1">
				<div style="flex: 1" class="br">
					<v-img
						eager
						contain
						class="mx-auto"
						max-width="200"
						max-height="130"
						src="@/assets/lusazu_logo.png"
						lazy-src="@/assets/lusazu_logo.png"
					/>
				</div>
				<div style="flex: 3" class="align-self-center">
					<div class="body-1 text-md-h4 font-weight-bold">
						CERTIFICADO DE SERVICIOS
					</div>
				</div>
				<div style="flex: 1" class="bl">
					<div class="mt-md-5 font-weight-medium body-1 text-md-h5">
						Resolucion Sanitaria
					</div>
					<div class="font-weight-medium text-md-body-1 font-weight-bold">
						Nº 7776-10-2019
					</div>
					<div class="font-weight-medium text-md-body-1 font-weight-bold">ISO 9001</div>
				</div>
			</div>
			<div class="text-left bb d-flex justify-space-between align-center">
				<div>
					<div class="body-2">
						REPRESENTANTE LEGAL: Luis Hernán Salazar Zuazo / RUT: 10.511.968-2
					</div>
					<div class="body-2">Calle Santa Lucia Nº 103 - Graneros</div>
					<div class="body-2">TELÉFONOS: +56 9 9638 3844</div>
				</div>
				<div v-if="order && order.id" class="title font-weight-bold">
					№ DR {{ order.id }}
				</div>
			</div>
			<div class="d-md-flex mt-md-2">
				<div style="flex: 1" class="bb d-md-flex align-md-center text-left">
					<div style="width: 70px" class="text-uppercase text-md-body-1 mr-2">
						Fecha
					</div>
					<input v-model="order.data[0]" style="width: 100%" type="date" />
				</div>
				<div style="flex: 1" class="bb d-md-flex align-md-center text-left">
					<div style="width: 200px" class="text-uppercase text-md-body-1 mr-2">
						HORA INICIO:
					</div>
					<input v-model="order.startHour" style="width: 100%" type="time" />
				</div>
				<div style="flex: 1" class="bb d-md-flex flex-no-wrap align-md-center text-left">
					<div style="width: 250px" class="text-uppercase text-md-body-1 mr-2">
						HORA TERMINO:
					</div>
					<input v-model="order.endHour" style="width: 100%" type="time" />
				</div>
			</div>
			<div class="d-md-flex align-center text-left mt-2">
				<div style="flex: 1" class="d-md-flex align-center">
					<label for="programados">
						SERVICIOS PROGRAMADOS
					</label>
					<input
						id="programados"
						class="ml-2"
						v-model="order.data[3]"
						style="width: 15px"
						type="checkbox"
					/>
				</div>
				<div style="flex: 1" class="d-md-flex align-center">
					<label for="extras">
						SERVICIOS EXTRAS
					</label>
					<input
						id="extras"
						class="ml-2"
						v-model="order.data[4]"
						style="width: 15px"
						type="checkbox"
					/>
				</div>
			</div>
			<div class="d-md-flex mt-2">
				<div style="flex: 1" class="bb d-md-flex flex-no-wrap align-md-center text-left">
					<div style="width: 70px" class="text-uppercase text-md-body-1 mr-2">
						CLIENTE:
					</div>
					<input v-model="order.data[6]" style="width: 100%" type="text" />
				</div>
				<div style="flex: 1" class="bb d-md-flex flex-no-wrap align-md-center text-left">
					<div style="width: 70px" class="text-uppercase text-md-body-1 mr-2">
						PLANTA:
					</div>
					<input v-model="order.data[7]" style="width: 100%" type="text" />
				</div>
			</div>
			<div style="flex: 2" class="bb d-md-flex flex-no-wrap align-md-center text-left">
				<div style="width: 100px" class="text-uppercase text-md-body-1 mr-2">
					Dirección:
				</div>
				<input v-model="order.data[8]" style="width: 100%" type="text" />
			</div>
			<div class="d-md-flex">
				<div style="flex: 2" class="bb d-md-flex flex-no-wrap align-md-center text-left">
					<div style="width: 280px" class="text-uppercase text-md-body-1 mr-2">
						Nombre solicitante:
					</div>
					<input v-model="order.data[9]" style="width: 100%" type="text" />
				</div>
				<div style="flex: 2" class="bb d-md-flex flex-no-wrap align-md-center text-left">
					<div style="width: 230px" class="text-uppercase text-md-body-1 mr-2">
						RUT solicitante:
					</div>
					<input v-model="order.data[10]" style="width: 100%" type="text" />
				</div>
			</div>
			<div style="flex: 2" class="bb d-md-flex flex-no-wrap align-md-center text-left">
				<div style="width: 230px" class="text-uppercase text-md-body-1 mr-2">
					Responsable planta:
				</div>
				<input v-model="order.data[11]" style="width: 100%" type="text" />
			</div>
			<div style="flex: 2" class="bb d-md-flex flex-no-wrap align-md-center text-left">
				<div style="width: 450px" class="text-uppercase text-md-body-1 mr-2">
					Tecnico responsable del trabajo:
				</div>
				<input v-model="order.data[12]" style="width: 100%" type="text" />
			</div>
			<div class="d-md-flex align-start mt-1">
				<div class="d-flex align-center justify-center justify-md-start">
					<span class="mr-2 font-italic body-1 text-uppercase">
						DESRATIZACIÓN
					</span>
				</div>
			</div>
			<div class="d-md-flex">
				<div style="flex: 1">
					<div class="text-left mb-2">
						<span style="font-size:16px; font-weight:bold;">
							Descripción de trampas
						</span>
					</div>
					<div class="mb-1 d-flex justify-space-between">
						<span>Número de trampas instaladas</span>
						<input class="ba" style="width: 20%" v-model="order.data[36]" />
					</div>
					<div class="mb-1 d-flex justify-space-between">
						<span>Trampas de tubo</span>
						<input class="ba" style="width: 20%" v-model="order.data[37]" />
					</div>
					<div class="mb-1 d-flex justify-space-between">
						<span>Trampas cajas pegajosas</span>
						<input class="ba" style="width: 20%" v-model="order.data[38]" />
					</div>
					<div class="mb-1 d-flex justify-space-between">
						<span>N° de Capturas Vivas</span>
						<input class="ba" style="width: 20%" v-model="order.data[121]" />
					</div>
				</div>
				<div style="flex: 1">
					<div class="text-left mb-2">
						<span style="font-size:16px; font-weight:bold;">Productos Utilizados</span>
					</div>
					<div class="text-left d-flex flex-wrap">
						<input
							type="checkbox"
							style="width: 10%;"
							v-model="itemsDesratizacion[0]"
						/>
						<div style="width: 90%; padding-left:10px;">
							RASTOP PLUS BLOQUE / BROMADIOLONA 0,005% +BENZOATO DE DENATORIO
							<br />
							ISP: 870/24
							<br />Dosis: 2 SACHET DE 10 GRS CADA UNO
						</div>
						<input
							type="checkbox"
							style="width: 10%;"
							v-model="itemsDesratizacion[1]"
						/>
						<span style="width: 90%; padding-left:10px;">
							RASTOP PELLET EN SOBRE / BROMADIOLONA 0,005% +BENZOATO DE DENATORIO ISP:
							<br />
							P-729/25
							<br />Dosis: 2 SACHET DE 10 GRS CADA UNO
						</span>
					</div>
				</div>
			</div>
			<v-row class="mb-3">
				<v-col cols="12" sm="6" md="3">
					<div class="d-flex">
						<div style="width: 36%" class="bl bt bb">
							<span style="font-size: 7px; font-weight:bold;">TIPO DE TRAMPA</span>
						</div>
						<div style="width: 32%" class="bl bt bb br">
							<span style="font-size: 7px; font-weight:bold;">Nº DE TRAMPA</span>
						</div>
						<div style="width: 32%" class="bt bb br">
							<span style="font-size: 7px; font-weight:bold;">Nº DE OBSERVACIÓN</span>
						</div>
					</div>
					<template v-if="itemsTrampas.length">
						<div class="bb" style="width: 100%" v-for="(x, index) in 20" :key="index">
							<div class="d-flex">
								<div style="height:18px; width: 36%" class="bl ">
									<input
										style="width: 100%"
										type="text"
										v-model="itemsTrampas[index].tipo"
									/>
								</div>
								<div style="height:18px; width: 32%" class="bl  br">
									<input
										style="width: 100%"
										type="number"
										v-model="itemsTrampas[index].numero"
									/>
								</div>
								<div style="height:18px; width: 32%" class="d-flex br">
									<input
										style="width: 80%"
										type="number"
										v-model="itemsTrampas[index].observacion"
									/>
									<div style="width: 20%; background-color: #e9efdf">
										<v-btn
											v-show="
												itemsTrampas[index].observacion &&
													itemsTrampas[index].tipo &&
													itemsTrampas[index].numero &&
													!itemsTrampas[index + 1].observacion &&
													!itemsTrampas[index + 1].tipo &&
													!itemsTrampas[index + 1].numero
											"
											x-small
											icon
											color="black"
											@click="
												() => {
													itemsTrampas[index + 1].observacion = parseInt(
														itemsTrampas[index].observacion
													);
													itemsTrampas[index + 1].tipo =
														itemsTrampas[index].tipo;
													itemsTrampas[index + 1].numero =
														parseInt(itemsTrampas[index].numero) + 1;
												}
											"
										>
											<v-icon>mdi-arrow-down-bold</v-icon>
										</v-btn>
									</div>
								</div>
							</div>
						</div>
					</template>
				</v-col>
				<v-col cols="12" sm="6" md="3">
					<div class="d-flex">
						<div style="width: 36%" class="bl bt bb">
							<span style="font-size: 7px; font-weight:bold;">TIPO DE TRAMPA</span>
						</div>
						<div style="width: 32%" class="bl bt bb br">
							<span style="font-size: 7px; font-weight:bold;">Nº DE TRAMPA</span>
						</div>
						<div style="width: 32%" class="bt bb br">
							<span style="font-size: 7px; font-weight:bold;">Nº DE OBSERVACIÓN</span>
						</div>
					</div>
					<template v-if="itemsTrampas.length">
						<template v-for="(x, index) in 40">
							<template v-if="x > 20">
								<div class="d-flex bb" :key="index">
									<div style="height:18px; width: 36%" class="bl ">
										<input
											style="width: 100%"
											type="text"
											v-model="itemsTrampas[index].tipo"
										/>
									</div>
									<div style="height:18px; width: 32%" class="bl  br">
										<input
											style="width: 100%"
											type="number"
											v-model="itemsTrampas[index].numero"
										/>
									</div>
									<div style="height:18px; width: 32%" class="d-flex br">
										<input
											style="width: 80%"
											type="number"
											v-model="itemsTrampas[index].observacion"
										/>
										<div style="width: 20%; background-color: #e9efdf">
											<v-btn
												v-show="
													itemsTrampas[index].observacion &&
														itemsTrampas[index].tipo &&
														itemsTrampas[index].numero &&
														!itemsTrampas[index + 1].observacion &&
														!itemsTrampas[index + 1].tipo &&
														!itemsTrampas[index + 1].numero
												"
												x-small
												icon
												color="black"
												@click="
													() => {
														itemsTrampas[
															index + 1
														].observacion = parseInt(
															itemsTrampas[index].observacion
														);
														itemsTrampas[index + 1].tipo =
															itemsTrampas[index].tipo;
														itemsTrampas[index + 1].numero =
															parseInt(itemsTrampas[index].numero) +
															1;
													}
												"
											>
												<v-icon>mdi-arrow-down-bold</v-icon>
											</v-btn>
										</div>
									</div>
								</div>
							</template>
						</template>
					</template>
				</v-col>
				<v-col cols="12" sm="6" md="3">
					<div class="d-flex">
						<div style="width: 36%" class="bl bt bb">
							<span style="font-size: 7px; font-weight:bold;">TIPO DE TRAMPA</span>
						</div>
						<div style="width: 32%" class="bl bt bb br">
							<span style="font-size: 7px; font-weight:bold;">Nº DE TRAMPA</span>
						</div>
						<div style="width: 32%" class="bt bb br">
							<span style="font-size: 7px; font-weight:bold;">Nº DE OBSERVACIÓN</span>
						</div>
					</div>
					<template v-if="itemsTrampas.length">
						<template v-for="(x, index) in 60">
							<template v-if="x > 40">
								<div class="d-flex bb" :key="index">
									<div style="height:18px; width: 36%" class="bl ">
										<input
											style="width: 100%"
											type="text"
											v-model="itemsTrampas[index].tipo"
										/>
									</div>
									<div style="height:18px; width: 32%" class="bl  br">
										<input
											style="width: 100%"
											type="number"
											v-model="itemsTrampas[index].numero"
										/>
									</div>
									<div style="height:18px; width: 32%" class="d-flex br">
										<input
											style="width: 80%"
											type="number"
											v-model="itemsTrampas[index].observacion"
										/>
										<div style="width: 20%; background-color: #e9efdf">
											<v-btn
												v-show="
													itemsTrampas[index].observacion &&
														itemsTrampas[index].tipo &&
														itemsTrampas[index].numero &&
														!itemsTrampas[index + 1].observacion &&
														!itemsTrampas[index + 1].tipo &&
														!itemsTrampas[index + 1].numero
												"
												x-small
												icon
												color="black"
												@click="
													() => {
														itemsTrampas[
															index + 1
														].observacion = parseInt(
															itemsTrampas[index].observacion
														);
														itemsTrampas[index + 1].tipo =
															itemsTrampas[index].tipo;
														itemsTrampas[index + 1].numero =
															parseInt(itemsTrampas[index].numero) +
															1;
													}
												"
											>
												<v-icon>mdi-arrow-down-bold</v-icon>
											</v-btn>
										</div>
									</div>
								</div>
							</template>
						</template>
					</template>
				</v-col>
				<v-col cols="12" sm="6" md="3">
					<div class="d-flex">
						<div style="width: 36%" class="bl bt bb">
							<span style="font-size: 7px; font-weight:bold;">TIPO DE TRAMPA</span>
						</div>
						<div style="width: 32%" class="bl bt bb br">
							<span style="font-size: 7px; font-weight:bold;">Nº DE TRAMPA</span>
						</div>
						<div style="width: 32%" class="bt bb br">
							<span style="font-size: 7px; font-weight:bold;">Nº DE OBSERVACIÓN</span>
						</div>
					</div>
					<template v-if="itemsTrampas.length">
						<template v-for="(x, index) in 80">
							<template v-if="x > 60">
								<div class="d-flex bb" :key="index">
									<div style="height:18px; width: 36%" class="bl ">
										<input
											style="width: 100%"
											type="text"
											v-model="itemsTrampas[index].tipo"
										/>
									</div>
									<div style="height:18px; width: 32%" class="bl  br">
										<input
											style="width: 100%"
											type="number"
											v-model="itemsTrampas[index].numero"
										/>
									</div>
									<div style="height:18px; width: 32%" class="d-flex br">
										<input
											style="width: 80%"
											type="number"
											v-model="itemsTrampas[index].observacion"
										/>
										<div style="width: 20%; background-color: #e9efdf">
											<v-btn
												v-show="
													itemsTrampas[index].observacion &&
														itemsTrampas[index].tipo &&
														itemsTrampas[index].numero &&
														!itemsTrampas[index + 1].observacion &&
														!itemsTrampas[index + 1].tipo &&
														!itemsTrampas[index + 1].numero &&
														index + 2 < itemsTrampas.length
												"
												x-small
												icon
												color="black"
												@click="
													() => {
														itemsTrampas[
															index + 1
														].observacion = parseInt(
															itemsTrampas[index].observacion
														);
														itemsTrampas[index + 1].tipo =
															itemsTrampas[index].tipo;
														itemsTrampas[index + 1].numero =
															parseInt(itemsTrampas[index].numero) +
															1;
													}
												"
											>
												<v-icon>mdi-arrow-down-bold</v-icon>
											</v-btn>
										</div>
									</div>
								</div>
							</template>
						</template>
					</template>
				</v-col>
			</v-row>
			<v-row>
				<v-col cols="12" md="4" order="4">
					<div style="font-size:16px; font-weight:bold;" class="text-left">
						Número de observaciones:
					</div>
					<v-row no-gutters justify="space-between" class="mb-1">
						<v-col cols="12" md="9" class="text-left">1-Captura</v-col>
						<v-col cols="12" md="3" class="text-left ba">
							<input type="text" style="width: 100%" v-model="order.data[41]" />
						</v-col>
					</v-row>
					<v-row no-gutters justify="space-between" class="mb-1">
						<v-col cols="12" md="9" class="text-left">2-Trampas bloqueadas</v-col>
						<v-col cols="12" md="3" class="text-left ba">
							<input type="text" style="width: 100%" v-model="order.data[42]" />
						</v-col>
					</v-row>
					<v-row no-gutters justify="space-between" class="mb-1">
						<v-col cols="12" md="9" class="text-left">3-Trampa destruida</v-col>
						<v-col cols="12" md="3" class="text-left ba">
							<input type="text" style="width: 100%" v-model="order.data[43]" />
						</v-col>
					</v-row>
					<v-row no-gutters justify="space-between" class="mb-1">
						<v-col cols="12" md="9" class="text-left">4-Babosas</v-col>
						<v-col cols="12" md="3" class="text-left ba">
							<input type="text" style="width: 100%" v-model="order.data[44]" />
						</v-col>
					</v-row>
					<v-row no-gutters justify="space-between" class="mb-1">
						<v-col cols="12" md="9" class="text-left">5-Hongos</v-col>
						<v-col cols="12" md="3" class="text-left ba">
							<input type="text" style="width: 100%" v-model="order.data[45]" />
						</v-col>
					</v-row>
					<v-row no-gutters justify="space-between" class="mb-1">
						<v-col cols="12" md="9" class="text-left">6-Polvo</v-col>
						<v-col cols="12" md="3" class="text-left ba">
							<input type="text" style="width: 100%" v-model="order.data[46]" />
						</v-col>
					</v-row>
					<v-row no-gutters justify="space-between" class="mb-1">
						<v-col cols="12" md="9" class="text-left">7-Sustraida</v-col>
						<v-col cols="12" md="3" class="text-left ba">
							<input type="text" style="width: 100%" v-model="order.data[47]" />
						</v-col>
					</v-row>
					<v-row no-gutters justify="space-between" class="mb-1">
						<v-col cols="12" md="9" class="text-left">8-Muestras roedores</v-col>
						<v-col cols="12" md="3" class="text-left ba">
							<input type="text" style="width: 100%" v-model="order.data[48]" />
						</v-col>
					</v-row>
					<v-row no-gutters justify="space-between" class="mb-1">
						<v-col cols="12" md="9" class="text-left">9-Trampas tratadas</v-col>
						<v-col cols="12" md="3" class="text-left ba">
							<input type="text" style="width: 100%" v-model="order.data[49]" />
						</v-col>
					</v-row>
				</v-col>
			</v-row>
			<div class="bb mt-2">
				<div class="text-left">
					<div class="text-uppercase text-md-body-1">Observaciones:</div>
					<textarea v-model="order.data[50]" rows="5" style="width: 100%;" type="text" />
				</div>
			</div>
			<div class="mt-10 d-sm-flex justify-space-between overflow-x-auto">
				<div>
					<template v-if="getUser.role === 'person' || query.edicion">
						<div class="bb text-left">
							<span style="width: 30%" class="text-uppercase text-md-body-1">
								Cliente:
							</span>
							<input v-model="order.cliente.nombre" style="width: 70%" type="text" />
						</div>
						<div class="bb text-left">
							<span style="width: 30%" class="text-uppercase text-md-body-1">
								RUT:
							</span>
							<input v-model="order.cliente.rut" style="width: 70%" type="text" />
						</div>
					</template>
					<div v-else class="bb text-left">
						<span style="width: 30%" class="text-uppercase body-1">
							Cliente:
						</span>
						<span class="body-2 text-capitalize">
							{{ order.cliente?.nombre }} {{ order.cliente?.rut }}
						</span>
					</div>
					<canvas-draw
						v-if="getUser.role === 'person'"
						class="mt-2"
						type="cliente"
					></canvas-draw>
					<template v-if="query.edicion && !getLoading">
						<v-switch
							class="ml-3"
							v-model="editarFirma"
							:label="editarFirma ? 'Ver firma cliente' : 'Editar firma cliente'"
						></v-switch>
						<canvas-draw
							id="cliente"
							v-if="editarFirma"
							class="mt-2"
							type="cliente"
						></canvas-draw>
						<v-img v-else height="200" eager contain :src="order.firma" alt="firma" />
					</template>
					<v-img
						v-if="!query.edicion && getUser.role !== 'person'"
						height="200"
						eager
						contain
						:src="order.firma"
						alt="firma"
					/>
					<span style="font-size: 19px">www.lusazu.cl</span>
				</div>
				<div>
					<template v-if="getUser.role === 'person' || query.edicion">
						<div class="bb text-left">
							<span style="width: 30%" class="text-uppercase text-md-body-1">
								Tecnico:
							</span>
							<input
								v-model="order.datosTecnico.nombre"
								style="width: 70%"
								type="text"
							/>
						</div>
						<div class="bb text-left">
							<span style="width: 30%" class="text-uppercase text-md-body-1">
								RUT:
							</span>
							<input
								v-model="order.datosTecnico.rut"
								style="width: 70%"
								type="text"
							/>
						</div>
					</template>
					<div v-else class="bb text-left">
						<span style="width: 30%" class="text-uppercase body-1">
							Tecnico:
						</span>
						<span class="body-2 text-capitalize">
							{{ order.datosTecnico.nombre }} {{ order.datosTecnico.rut }}
						</span>
					</div>
					<canvas-draw
						v-if="getUser.role === 'person'"
						class="mt-2"
						type="tecnico"
					></canvas-draw>
					<template v-if="query.edicion && !getLoading">
						<v-switch
							class="ml-3"
							v-model="editarFirmaTecnico"
							:label="
								editarFirmaTecnico ? 'Ver firma tecnico' : 'Editar firma tecnico'
							"
						></v-switch>
						<canvas-draw
							id="tecnico"
							v-if="editarFirmaTecnico"
							class="mt-2"
							type="tecnico"
						></canvas-draw>
						<v-img
							v-else
							height="200"
							eager
							contain
							:src="order.firmaTecnico"
							alt="firma"
						/>
					</template>
					<v-img
						v-if="!query.edicion && getUser.role !== 'person'"
						height="200"
						eager
						contain
						:src="order.firmaTecnico"
						alt="firma"
					/>
					<span style="font-size: 19px">info@lusazu.cl</span>
				</div>
			</div>
			<!-- End Form -->
			<div class="page-break"></div>
			<v-col v-if="images.length" cols="12">Antecedentes fotográficos:</v-col>
			<div style="width: 100%">
				<div class="d-md-flex flex-wrap" v-if="images.length">
					<div v-for="(img, key) in images" :key="key">
						<a target="_blank" :href="img.url">
							<v-img
								lazy-src="@/assets/placeholder.png"
								:src="img.url"
								class="mr-1 foto-antecedentes"
								alt="imagen de la orden"
							>
								<div class="bg caption text-right">{{ createAt(img._id) }}</div>
							</v-img>
						</a>
					</div>
				</div>
			</div>
			<div class="my-6">
				<div v-if="getUser.role === 'person'" class="d-flex justify-center">
					<v-checkbox
						v-if="lodgingSelect"
						dense
						v-model="order.correo"
						:value="lodgingSelect.place.email[0]"
						:label="`¿Desea enviar email a ${lodgingSelect.place.email[0]}?`"
					>
					</v-checkbox>
				</div>
				<v-btn
					:loading="loadingPrev"
					class="mx-2"
					outlined
					color="#7a972c"
					@click="prepararOT"
				>
					Preparar OT
				</v-btn>
				<template v-if="getUser.role === 'person'">
					<v-btn
						:loading="loading"
						class="mx-2"
						outlined
						color="#7a972c"
						@click="onSubmit"
					>
						Guardar
					</v-btn>
				</template>
				<template v-else>
					<v-btn
						:loading="editLoading"
						class="mx-2"
						outlined
						color="#7a972c"
						@click="editarOT"
						:disabled="!lodgingSelect"
						v-if="query.edicion"
					>
						EDITAR ESTA ORDEN
					</v-btn>
					<v-btn
						:loading="loading"
						class="mx-2"
						outlined
						color="#7a972c"
						@click="sendCertify"
						v-else
					>
						Certificar
					</v-btn>
				</template>
			</div>
		</v-container>
	</div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import { setUserWithToken } from '@/plugins/auth';
import recommendations from '../../../assets/lusazu/recommendations.json';
import moment from 'moment';

export default {
	components: {
		CanvasDraw: () => import('@/components/ui/CanvasDraw'),
	},
	data() {
		return {
			editLoading: false,
			editarFirma: false,
			editarFirmaTecnico: false,
			getLoading: false,
			loading: false,
			query: null,
			params: null,
			image: null,
			order: {
				date: undefined,
				data: [],
				id: undefined,
				user: undefined,
				correo: '',
				cliente: { nombre: undefined, rut: undefined },
				datosTecnico: { nombre: undefined, rut: undefined },
				imagen: { date: undefined, image: undefined },
				type: 'roedores',
				firma: '',
				firmaTecnico: '',
				tecnico: '',
				endHour: '',
				startHour: '',
				vigencia: '',
				reco2: '',
				reco3: '',
				recosType: [],
				sanitizacion: false,
				desinsectacion: false,
				desratizado: true,
				itemsTrampas: [],
			},
			itemsDesratizacion: [],
			images: [],
			itemsTrampas: [],
			loadingPrev: false,
			recommendations,
		};
	},
	computed: {
		...mapGetters({
			lodgingSelect: 'Lodging/lodgingSelect',
			getUser: 'User/profile',
			person: 'Person/person',
			firmaString: 'Lodging/firma',
			firmaTecnicoString: 'Lodging/firmaTecnico',
		}),
	},
	created() {
		this.query = this.$route.query;
		this.params = this.$route.params;
	},
	async mounted() {
		this.$nextTick(function() {
			this.itemsTrampas = Array.from(Array(81), () => ({
				tipo: '',
				numero: undefined,
				observacion: undefined,
			}));
		});
		if (this.query.bearerToken) {
			await setUserWithToken({ token: this.query.bearerToken });
			await this.fetchInit();
		} else if ((this.query.idLodging || this.params.idLodging) && !this.lodgingSelect)
			await this.fetchInit();
		this.lodgingId = this.$route.params.idLodging;
		this.indexWorkOrder = this.$route.params.index;
		this.indexWorkOrder = this.$route.params.index;
		if (this.lodgingId) {
			this.getLoading = true;
			this.getWorkOrder({
				idLodging: this.lodgingId,
				indexWorkOrder: this.indexWorkOrder,
			}).then(data => {
				this.order = data.workOrder;
				this.itemsSanitizacion = this.order.data[22];
				this.itemsDesinsectacion = this.order.data[28];
				this.itemsDesratizacion = this.order.data[39];
				this.itemsTrampas = this.order.data[40];
				this.place = data.place;
				this.images = data.documents.filter(document => {
					const typeDocument = document.url.slice(-3);
					if (this.validateImage(typeDocument)) return true;
					return false;
				});
				this.getLoading = false;
			});
		}
		if (this.lodgingSelect && !this.lodgingId) {
			this.setValuesDefault();
			this.lodgingId = this.lodgingSelect._id;
		}
	},
	methods: {
		addTrampa() {
			this.itemsTrampas.push({
				tipo: '',
				numero: undefined,
				observacion: undefined,
			});
		},
		removeTrampa() {
			this.itemsTrampas.pop();
		},
		validateImage(typeDocument) {
			typeDocument = typeDocument.toLowerCase();
			if (typeDocument === 'jpg' || typeDocument === 'png' || typeDocument === 'peg')
				return true;
			return false;
		},
		createAt(id) {
			const date = new Date(parseInt(id.substring(0, 8), 16) * 1000);
			if (date) return moment(date).format('lll');
			else return 'Sin fecha';
		},

		async fetchInit() {
			try {
				console.log('fetch init');
				await this.getLodging(this.query.idLodging || this.params.idLodging);
				this.setPerson(this.lodgingSelect.person);
			} catch (error) {
				console.log(error);
			}
		},
		async prepararOT() {
			this.loadingPrev = true;
			this.order.type = 'pre-roedores';
			this.order.firma = this.firmaString;
			this.order.firmaTecnico = this.firmaTecnicoString;
			this.order.data[39] = this.itemsDesratizacion;
			this.order.data[40] = this.itemsTrampas;
			const data = JSON.stringify(this.order);
			const payload = new FormData();
			payload.append('image', this.image);
			payload.append('order', data);
			await this.createWorkOrder({
				idLodging: this.lodgingSelect
					? this.lodgingSelect._id
					: this.$route.params.idLodging,
				payload,
			});
			this.image = null;
			this.setFirma('');
			this.setFirmaTecnico('');
			this.loadingPrev = false;
			this.setLodgingSelect(null);
			this.$router.push('/guest/timeline');
		},
		async onSubmit() {
			this.loading = true;
			this.order.type = 'roedores';
			this.order.firma = this.firmaString;
			this.order.firmaTecnico = this.firmaTecnicoString;
			this.order.data[39] = this.itemsDesratizacion;
			this.order.data[40] = this.itemsTrampas;
			const data = JSON.stringify(this.order);
			const payload = new FormData();
			payload.append('image', this.image);
			payload.append('order', data);
			await this.createWorkOrder({
				idLodging: this.lodgingSelect
					? this.lodgingSelect._id
					: this.$route.params.idLodging,
				payload,
			});
			this.image = null;
			this.setFirma('');
			this.setFirmaTecnico('');
			this.loading = false;
			this.setLodgingSelect(null);
			this.$router.push('/guest/timeline');
		},
		async sendCertify() {
			this.loading = true;
			this.order.data[39] = this.itemsDesratizacion;
			this.order.data[40] = this.itemsTrampas;
			this.order.type = 'roedores-certificate';
			const data = JSON.stringify(this.order);
			const payload = new FormData();
			payload.append('image', this.image);
			payload.append('order', data);
			await this.certifyWorkOrder({
				idLodging: this.lodgingId,
				indexWorkOrder: this.indexWorkOrder,
				payload,
			});
			this.image = null;
			this.loading = false;
			this.fetchPlace();
			this.$router.push({ name: 'places' });
		},
		async editarOT() {
			this.editLoading = true;
			this.order.data[22] = this.itemsSanitizacion;
			this.order.data[28] = this.itemsDesinsectacion;
			this.order.data[39] = this.itemsDesratizacion;
			this.order.data[40] = this.itemsTrampas;
			this.order.firma = this.editarFirma ? this.firmaString : this.order.firma;
			this.order.firmaTecnico = this.editarFirmaTecnico
				? this.firmaTecnicoString
				: this.order.firmaTecnico;
			const payload = {
				lodging: this.lodgingId,
				index: this.indexWorkOrder,
				workOrder: this.order,
			};
			this.order = await this.atualizarOT(payload);
			this.editarFirma = false;
			this.editarFirmaTecnico = false;
			this.setFirma('');
			this.setFirmaTecnico('');
			this.editLoading = false;
		},
		setValuesDefault() {
			for (var i = 0; i <= 126; i++) {
				this.order.data.push(null);
			}
			if (this.lodgingSelect.histories) {
				const todayHistory = this.filterTodayHistory(this.lodgingSelect.histories);
				this.order.startHour = todayHistory ? moment(todayHistory.in).format('HH:mm') : '';
			}
			this.order.data[0] = moment().format('YYYY-MM-DD');
			this.order.data[1] = this.lodgingSelect.group;
			this.order.data[6] = this.lodgingSelect.place.name;
			this.order.data[23] = '';
			this.order.data[35] = '';
			this.order.data[50] = '';
			this.recommendations.Desratizacion.forEach(item => {
				this.order.data[50] += item + '\n';
			});
			// this.order.data[6] = this.lodgingSelect.place.direction;
			// this.order.data[7] = this.lodgingSelect.place.rut;
			this.order.data[8] = this.lodgingSelect.place.direction;
			this.order.data[9] = this.lodgingSelect.place.nombreSolicitante;
			this.order.data[10] = this.lodgingSelect.place.rutSolicitante;
			// this.order.data[11] = this.lodgingSelect.place.direccionSolicitante;
			this.order.data[12] = `${this.lodgingSelect.person.firstName.toUpperCase()} ${
				this.lodgingSelect.person.lastName
					? this.lodgingSelect.person.lastName.toUpperCase()
					: ''
			}`;
			this.order.date = moment().format('DD/MM/YY');
			this.order.endHour = moment().format('HH:mm');
		},
		filterTodayHistory(histories) {
			return histories.find(history => {
				const checkIn = moment(history.in);
				const today = moment();
				if (today.isSame(checkIn, 'day')) return history;
			});
		},
		...mapMutations({
			setLodgingSelect: 'Lodging/setLodgingSelect',
			setPerson: 'Person/setPerson',
			setFirma: 'Lodging/setFirma',
			setFirmaTecnico: 'Lodging/setFirmaTecnico',
		}),
		...mapActions({
			atualizarOT: 'Lodging/atualizarOT',
			createWorkOrder: 'Lodging/createWorkOrder',
			certifyWorkOrder: 'Lodging/certifyWorkOrder',
			updateLodging: 'Lodging/updateLodging',
			getLodging: 'Lodging/getLodging',
			getWorkOrder: 'Lodging/getWorkOrder',
			fetchPlace: 'Lodging/fetchPlace',
		}),
	},
};
</script>

<style scoped>
textarea {
	background-color: #e9efdf !important;
}
input {
	height: 18px;
	border: 1px solid gray;
	background-color: #e9efdf !important;
}
.nw {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}
.marca-agua {
	position: absolute;
	top: 40%;
	left: 30%;
	opacity: 0.1;
	z-index: 1;
}
* {
	color: black;
	-webkit-print-color-adjust: exact !important;
	color-adjust: exact !important;
	font-size: 12px;
}
/* Tamaño pagina 1056 1392 px  */
@media print {
	@page {
		size: A3 portrait;
		width: 100%;
		margin: auto;
	}
	.firmas {
		max-height: 90px !important;
		height: 90px !important;
	}
	.antecedentes-fotograficos {
		display: none;
	}
	.border-ot {
		display: table;
		margin: 0 auto;
		border: 0px !important;
	}
	.page-break {
		display: block;
		page-break-before: always;
	}
}
.border-a {
	border-bottom: 2px solid gray !important ;
	margin-bottom: 2px;
	width: 98%;
	max-width: 1050px;
	height: 1300px;
}
.ba {
	border: 1px solid black;
}
.bl {
	border-left: 1px solid black;
}
.br {
	border-right: 1px solid black;
}
.bt {
	border-top: 1px solid black;
}
.bb {
	border-bottom: 1px solid black;
}
.bg {
	background-color: #80bd00;
	color: white;
}
.bg-secondary {
	background-color: #f6c90071;
}
.cc {
	width: 30px;
	height: 15px;
}
.border-ot {
	background-color: white;
	margin: 5px auto;
	width: 100%;
	max-width: 1050px;
}
.foto-antecedentes {
	border-radius: 15px;
	margin-bottom: 50px;
	height: 200px;
	width: 200px;
	border: 1px solid black;
}

.text--color {
	color: rgba(255, 255, 255, 0.74);
}

input {
	border: none;
	font-size: 16px;
	background-color: #ffffff;
	outline: none;
	padding: 0 5px;
}
select {
	border: none;
	background-color: #ffffff;
	outline: none;
	padding: 0 5px;
}
textarea {
	font-size: 18px;
	outline: none;
}
</style>
